class Chart {
  constructor(sidebar, map, udFilters, tsFilters, breakoutTable, config = {}) {
    this.data = config.data;
    this.sidebar = sidebar;
    this.breakoutTable = breakoutTable;
    this.udFilters = udFilters;
    this.tsFilters = udFilters;
    this.map = map;
    this.chartDimensions= {};
  }

  clearChart(data) {
    if (document.querySelector('svg#d3-graph') !== null) {
      document.querySelector('svg#d3-graph').remove();
    };
    if (document.querySelector('.no-data-message') !== null) {
      document.querySelector('.no-data-message').remove();
    };
    return this;
  }

  handleNoData() {
    const message = '<div class="no-data-message">No Data Returned for the Current Selections</div>';
    document.querySelector(".data-display-container #graph").innerHTML = message;
    return this;
  }

  /**
   * This method is used to calculate the min/max values for the upstream to downstream dataset
   * The method collapses the values across all value fields into an array for each record
   * That array is then flattened into a single array that the d3.extent method is then run on
   * @param  {array} data [data to evaluate]
   * @return {array}      [returns an array of the min and max]
   */
  calcExtent(data) {
    const minMaxes = data.map( d => {
      let values = [parseFloat(d.native_flow), parseFloat(d.releases), parseFloat(d.exchanges), parseFloat(d.other_admin), parseFloat(d.measured_flow) ];
      return [d3.min(values), d3.sum(values)];
    });
    const flattenedminMaxes = [].concat(...minMaxes);
    const extent = d3.extent(flattenedminMaxes);
    return extent;
  }

  /**
   * This method is used to set the chart dimensions
   * @param {string} selector  [CSS selector for chart]
   * @param {object} [margin] [margins to apply]
   * @return {object} [chart dimensions]
   */
  setChartDimensions(selector, margin = { top: 15, right: 15, bottom: 25, left: 50 }) {
    let width = d3.select(selector).style('width');
    width = parseInt(width.substring(0, width.length -2)) * .95;

    let height = width * .35;

    // Subtract margins from width and height
    width = width - margin.left - margin.right,
    height = height - margin.top - margin.bottom;

    const chartDimensions = {
      margin: margin,
      width: width,
      height: height
    }
    this.chartDimensions = chartDimensions;
    return chartDimensions;
  };

  toggleProgressSpinner() {

  }

  createSidebarContent(data, fields) {
    let html = `<ul class="sidebar-list">`;
    let fieldKeys = Object.keys(fields);
    let fieldValues = Object.values(fields);
    let li = fieldKeys.map( (field, index) => {
      return `
        <li>
          <span class="sidebar-list-legend ${field}"></span>
          <span class="sidebar-list-legend-title">${fieldValues[index]} - </span>
          <span class="sidebar-list-legend-value">${data[field]} CFS</span>
        </li>
      `;
    });
    html += `${li.join("")}</ul>`;
    return html;
  }

  updateBreakoutTable(type, self, scale) {
    // grab the location of the users cursor and convert it to a meaningful x-axis value
    let gageAbbrev;

    if ( type === "upstream-downstream" ) {
      const xPos = d3.mouse(self)[0];
      const domain = scale.domain();
      const range = scale.range();
      const rangePoints = d3.range(range[0], range[1], scale.step())
      gageAbbrev = domain[d3.bisect(rangePoints, xPos) -1];
      this.breakoutTable.filteredData = this.breakoutTable.data.filter((d) => {
        return d.location === gageAbbrev && d.adate === this.udFilters.filters[0].getDate();
      });
    } else if ( type === "time-series" ) {
      const date = scale.invert(d3.mouse(self)[0]);
      const formatDate = d3.timeFormat('%Y-%m-%d');
      const formattedDate = formatDate(date);
      const activeData = this.data.filter( d => d.ddate === formattedDate )[0];
      gageAbbrev = activeData.location;
      this.breakoutTable.filteredData = this.breakoutTable.data.filter((d) => {
        return d.location === gageAbbrev && d.adate === formattedDate;
      });
    }

    this.breakoutTable.clearTable();
    this.breakoutTable.build();
    this.breakoutTable.updateTitle(gageAbbrev);
    return this;
  }

  /**
  * This function is used to create the tooltip band/line that indicates the active value the user is hovering over
  */
  generateTooltipLine(type, self, scale, tooltipBar, tooltipLine) {
    // grab the location of the users cursor and convert it to a meaningful x-axis value
    let x0 = parseInt(d3.mouse(self)[0]);
    let activeData;
    let sidebarTitle;
    let gageAbbrev;

    if ( type === "upstream-downstream" ) {
      const xPos = d3.mouse(self)[0];
      const domain = scale.domain();
      const range = scale.range();
      const rangePoints = d3.range(range[0], range[1], scale.step())
      gageAbbrev = domain[d3.bisect(rangePoints, xPos) -1];
      sidebarTitle = gageAbbrev
      activeData = this.data.filter( d => d.location === gageAbbrev )[0];
    } else if ( type === "time-series" ) {
      const date = scale.invert(d3.mouse(self)[0]);
      const formatDate = d3.timeFormat('%Y-%m-%d');
      const formattedDate = formatDate(date);
      activeData = this.data.filter( d => d.ddate === formattedDate )[0];
      gageAbbrev = activeData.location;
      sidebarTitle = `${activeData.location} - ${activeData.ddate}`;
    }

    const sidebarContent = this.createSidebarContent(activeData, {
      "native_flow": "Native Flow",
      "releases": "Releases",
      "other_admin": "BOR Project Water",
      "exchanges": "Exchanges",
      "measured_flow": "Measured Flow"
    });

    this.sidebar.updateTitle(sidebarTitle);
    this.sidebar.updateContent(sidebarContent);        

    this.map.highlightMapLocation(gageAbbrev);

    // The tooltip bar is appended to the graph when it is rendered
    // This sets the coordinates of the bar as well as the display styles
    tooltipBar
      .attr('x1', x0)
      .attr('x2', x0)
      .attr('y1', 0)
      .attr('y2', this.chartDimensions.height)
      .style('stroke', '#5d86ff')
      .style('stroke-width', '36px')
      .style('opacity', 0.1);

    // The tooltip line is appended to the graph when it is rendered
    // This sets the coordinates of the line as well as the display styles
    tooltipLine
      .attr('x1', x0)
      .attr('x2', x0)
      .attr('y1', 0)
      .attr('y2', this.chartDimensions.height)
      .style('stroke', '#5d86ff')
      .style('stroke-width', '1px')
      .style('opacity', 0.8);
  } // generateTooltipLine()

  generateTooltipLineFromMap(gage) {
    const x = this.x;
    const y = this.y;
    const xPos = x(gage);

    const tooltipBar = d3.select('.tooltip-line1');
    const tooltipLine = d3.select('.tooltip-line2');

    tooltipBar
      .attr('x1', xPos)
      .attr('x2', xPos)
      .attr('y1', 0)
      .attr('y2', this.chartDimensions.height)
      .style('stroke', '#5d86ff')
      .style('stroke-width', '36px')
      .style('opacity', 0.1);

    tooltipLine
      .attr('x1', xPos)
      .attr('x2', xPos)
      .attr('y1', 0)
      .attr('y2', this.chartDimensions.height)
      .style('stroke', '#5d86ff')
      .style('stroke-width', '1px')
      .style('opacity', 0.8);

    const activeData = this.data.filter( d => d.location === gage )[0];
    const sidebarContent = this.createSidebarContent(activeData, {
      "native_flow": "Native Flow",
      "releases": "Releases",
      "other_admin": "BOR Project Water",
      "exchanges": "Exchanges",
      "measured_flow": "Measured Flow"
    });
    this.sidebar.updateTitle(gage);
    this.sidebar.updateContent(sidebarContent);
 } // generateTooltipLine()

  /**
   * This utility method is used to return the y value for a data point for a specified set of fields
   * This method is necessary for a stacked area chart when the y value needs to be a function of the
   * other series present on the graph
   * For instance let's say that the first series called releases has a y-value of 50 at a given x-value.
   * The second series, Native Flow, needs to add this value of 50 for the releases series for the same x-value
   * when the data is being portrayed as a stacked line or area chart
   * This method is called on a single record and used as part of the accessor function for setting y coordinates
   * for a D3 line/area chart
   * @param  {object} data   [record to analyze]
   * @param  {array} fields [array of fields that need to be summed]
   * @return {number}        [returns either a sum of the values for specified fields or 0]
   */
  calcY(data, fields) {
    if ( fields.length > 0 ) {
      let arr = fields.map( field => parseFloat(data[field]) );
      return d3.sum(arr);
    } else {
      return 0;
    }
  }

  /**
   * This utility method us used to create an D3 area series constructor
   * This method relies on the calcy() utility method to create a stacked area chart
   * @param  {array} y0Fields [fields to be be summed to calculate the y0 value]
   * @param  {array} y1Fields [fields to be be summed to calculate the y1 value]
   * @param  {object} x [x scale]
   * @param  {object} y [y scale]
   * @return {function}          [returns a D3 area constructor]
   */
  createArea(xField, y0Fields, y1Fields, x, y) {
    return d3.area()
      // .curve(d3.curveBasis)
      .x(d => {
        if ( xField === "ddate" ) {
          return x(new Date(`${d[xField]} 00:00:00`));
        } else {
          return x(d[xField]);
        }
      })
      .y0(d =>  y(this.calcY(d, y0Fields)))
      .y1(d => y(this.calcY(d, y1Fields)))
  }

  /**
   * This utility method us used to create an D3 line series constructor
   * This method relies on the calcy() utility method to create a stacked line chart
   * @param  {array} yFields [fields to be be summed to calculate the y value]
   * @param  {object} x [x scale]
   * @param  {object} y [y scale]
   * @return {function}          [returns a D3 line constructor]
   */
  createLine(xField, yFields, x, y) {
    return d3.line()
      // .curve(d3.curveBasis)
      .x(d => {
        if ( xField === "ddate" ) {
          return x(new Date(`${d[xField]} 00:00:00`));
        } else {
          return x(d[xField]);
        }
      })
      .y(d => y(this.calcY(d, yFields)))
  }

  /**
   * This utility method is used as a shorthand for appending a line or area series to the chart
   * @param  {object} svg      [svg to append to]
   * @param  {array} data      [data to plot]
   * @param  {string} classList [list of classes to assign the series]
   * @param  {function} series    [D3 line/area constructor to be used to plot the data]
   * @return {object}           [Returns DOM/SVG node]
   */
  appendSeries(svg, data, classList, series) {
    return svg.append("path")
      .datum(data)
      .attr("class", classList)
      .attr("d", series);
  }

  /**
   * This method is used to create the upstream to downstream chart
   * @return {object} [returns this]
   */
  createUDChart() {
    const chartDimensions = this.setChartDimensions('.data-display-container #graph');
    const width = chartDimensions.width;
    const height = chartDimensions.height;
    const margin = chartDimensions.margin;
    const progressSpinner = document.querySelector('#progress-spinner-wrapper');
    let data = this.data;
    const self = this;

    this.clearChart();

    if ( progressSpinner !== null ) {
      progressSpinner.style.display = 'none';
    }

    if ( data.length === 0 ) {
      this.handleNoData();
      return;
    }

    // Hide graph initially to fade in later
    const graphContainer = document.querySelector('.data-display-container #graph');
    // graphContainer.style.display = "none";

    // Create the x and y graph scales and set the ranges for the graph
    const x = d3.scalePoint().range([0, width]).padding(0.1);
    const y = d3.scaleLinear().range([height, 0]);
    this.x = x;
    this.y = y;

    // Create the x and y domains for the graph aka the min/max x and y axis values
    x.domain(data.map( d => d.location));
    y.domain(this.calcExtent(data));

    // Create the SVG
    const svg = d3.select('.data-display-container #graph')
      .append("svg")
        .attr("width", width + margin.left + margin.right)
        .attr("height", height + margin.top + margin.bottom)
        .attr("id", "d3-graph")
      .append("g")
        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

    // Create the x axis gridlines
    const xAxisGridlines = g => g
      .attr("class", "x-axis grid")
      .attr("transform", `translate(0,${height})`)
      .call(
        d3.axisBottom(x).tickSize(-height).tickFormat("")
      )

    // Create the y-axis gridlines
    const yAxisGridlines = g => g
      .attr("class", "y-axis grid")
      .call(
        d3.axisLeft(y).tickSize(-width).tickFormat("")
      )
      // .call(g => g.select(".domain").remove())

    // Create the x-axis
    const xAxis = g => g
      .attr("class", "x-axis")
      .attr("transform", `translate(0,${height})`)
      .call(
        d3.axisBottom(x)
      )

    // Create the y-axis
    const yAxis = g => g
      .attr("class", "y-axis")
      .call(
        d3.axisLeft(y)
      )

    // Append the axis gridlines and axes themselves
    svg.append("g").call(xAxisGridlines);
    svg.append("g").call(yAxisGridlines);
    svg.append("g").call(xAxis);
    svg.append("g").call(yAxis);

    // Create the D3 area constructors
    const nativeFlowArea = this.createArea("location", [], ["native_flow"], x, y);
    const releasesArea = this.createArea("location", ["native_flow"], ["native_flow", "releases"], x, y);
    const otherArea = this.createArea("location", ["releases", "native_flow"], ["releases", "native_flow", "other_admin"], x, y);
    const exchangeArea = this.createArea("location", ["releases", "native_flow", "other_admin"], ["releases", "native_flow", "other_admin", "exchanges"], x, y);

    // Create the D3 line constructors
    const nativeFlowLine = this.createLine("location", ["native_flow"], x, y);
    const releasesLine = this.createLine("location", ["native_flow", "releases"], x, y);
    const otherLine = this.createLine("location", ["releases", "native_flow", "other_admin"], x, y);
    const exchangeLine = this.createLine("location", ["releases", "native_flow", "other_admin", "exchanges"], x, y);
    const measuredLine = this.createLine("location", ["measured_flow"], x, y);

    // Append the area series
    const nativeFlowAreaSeries = this.appendSeries(svg, data, "area native-flow", nativeFlowArea);
    const releasesAreaSeries = this.appendSeries(svg, data, "area releases", releasesArea);
    const otherAreaSeries = this.appendSeries(svg, data, "area other-admin", otherArea);
    const exchangeAreaSeries = this.appendSeries(svg, data, "area exchange", exchangeArea);

    // Append the line series
    const nativeFlowLineSeries = this.appendSeries(svg, data, "line divider-line", nativeFlowLine);
    const releasesLineSeries = this.appendSeries(svg, data, "line divider-line", releasesLine);
    const otherLineSeries = this.appendSeries(svg, data, "line divider-line", otherLine);
    const exchangeLineSeries = this.appendSeries(svg, data, "line divider-line", exchangeLine);
    const measuredLineSeries = this.appendSeries(svg, data, "line measured-flow-line", measuredLine);

    // Append the measured flow series circle outlines
    svg.selectAll(".measured-flow-circle-outline")
        .data(this.data)
      .enter().append("circle")
        .attr("class", "measured-flow-circle-outline")
        .attr("cx", function(d) { return x(d.location); })
        .attr("cy", function(d) { return y(d.measured_flow); })
        .attr("r", 8);

    // Append the measured flow series circles
    svg.selectAll(".measured-flow-circle")
        .data(this.data)
      .enter().append("circle")
        .attr("class", "measured-flow-circle")
        .attr("cx", function(d) { return x(d.location); })
        .attr("cy", function(d) { return y(d.measured_flow); })
        .attr("r", 4);

    // Add an empty tooltip bar and line
    const tooltipBar = svg.append('line').attr('class', 'tooltip-line1');
    const tooltipLine = svg.append('line').attr('class', 'tooltip-line2');

    // Add an overlay to the chart so we can append the tooltip lines on hover
    const rect = svg.append("rect")
      .attr("transform", "translate(0,0)")
      .attr("class", "overlay")
      .style("opacity", 0)
      .attr("width", width)
      .attr("height", height)
      .on("mousemove", function() {
        self.generateTooltipLine("upstream-downstream", this, x, tooltipBar, tooltipLine)
      })
      .on("click", function() {
        self.updateBreakoutTable("upstream-downstream", this, x, tooltipBar, tooltipLine)
      });
    return this;
  } // createUDChart()

  createTSChart() {
    const chartDimensions = this.setChartDimensions('.data-display-container #graph');
    const width = chartDimensions.width;
    const height = chartDimensions.height;
    const margin = chartDimensions.margin;
    const progressSpinner = document.querySelector('#progress-spinner-wrapper');
    let data = this.data;
    const self = this;

    this.clearChart();

    if ( progressSpinner !== null ) {
      progressSpinner.style.display = 'none';
    }

    if ( data.length === 0 ) {
      this.handleNoData();
      return;
    }

    // Hide graph initially to fade in later
    const graphContainer = document.querySelector('.data-display-container #graph');
    // graphContainer.style.display = "none";

    // Create the x and y graph scales and set the ranges for the graph
    const x = d3.scaleTime().range([5, width-5]);
    const y = d3.scaleLinear().range([height, 0]);
    this.x = x;
    this.y = y;

    // Create the x and y domains for the graph aka the min/max x and y axis values
    x.domain(d3.extent(data, d => new Date(`${d.ddate} 00:00:00`)));
    y.domain(this.calcExtent(data));

    // Create the SVG
    const svg = d3.select('.data-display-container #graph')
      .append("svg")
        .attr("width", width + margin.left + margin.right)
        .attr("height", height + margin.top + margin.bottom)
        .attr("id", "d3-graph")
      .append("g")
        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

    // Create the x axis gridlines
    const xAxisGridlines = g => g
      .attr("class", "x-axis grid")
      .attr("transform", `translate(0,${height})`)
      .call(
        d3.axisBottom(x).tickSize(-height).tickFormat("")
      )

    // Create the y-axis gridlines
    const yAxisGridlines = g => g
      .attr("class", "y-axis grid")
      .call(
        d3.axisLeft(y).tickSize(-width).tickFormat("")
      )
      // .call(g => g.select(".domain").remove())

    // Create the x-axis
    const xAxis = g => g
      .attr("class", "x-axis")
      .attr("transform", `translate(0,${height})`)
      .call(
        d3.axisBottom(x).tickFormat(d3.timeFormat("%b %d"))
      )

    // Create the y-axis
    const yAxis = g => g
      .attr("class", "y-axis")
      .call(
        d3.axisLeft(y)
      )

    // Append the axis gridlines and axes themselves
    svg.append("g").call(xAxisGridlines);
    svg.append("g").call(yAxisGridlines);
    svg.append("g").call(xAxis);
    svg.append("g").call(yAxis);

    // Create the D3 area constructors
    const nativeFlowArea = this.createArea("ddate", [], ["native_flow"], x, y);
    const releasesArea = this.createArea("ddate", ["native_flow"], ["releases", "native_flow"], x, y);
    const otherArea = this.createArea("ddate", ["releases", "native_flow"], ["releases", "native_flow", "other_admin"], x, y);
    const exchangeArea = this.createArea("ddate", ["releases", "native_flow", "other_admin"], ["releases", "native_flow", "other_admin", "exchanges"], x, y);

    // Create the D3 line constructors
    const nativeFlowLine = this.createLine("ddate", ["native_flow"], x, y);
    const releasesLine = this.createLine("ddate", ["native_flow", "releases"], x, y);
    const otherLine = this.createLine("ddate", ["releases", "native_flow", "other_admin"], x, y);
    const exchangeLine = this.createLine("ddate", ["releases", "native_flow", "exchanges", "other_admin"], x, y);
    const measuredLine = this.createLine("ddate", ["measured_flow"], x, y);

    // Append the area series
    const nativeFlowAreaSeries = this.appendSeries(svg, data, "area native-flow", nativeFlowArea);
    const releasesAreaSeries = this.appendSeries(svg, data, "area releases", releasesArea);
    const otherAreaSeries = this.appendSeries(svg, data, "area other-admin", otherArea);
    const exchangeAreaSeries = this.appendSeries(svg, data, "area exchange", exchangeArea);

    // Append the line series
    const nativeFlowLineSeries = this.appendSeries(svg, data, "line divider-line", nativeFlowLine);
    const releasesLineSeries = this.appendSeries(svg, data, "line divider-line", releasesLine);
    const otherLineSeries = this.appendSeries(svg, data, "line divider-line", otherLine);
    const exchangeLineSeries = this.appendSeries(svg, data, "line divider-line", exchangeLine);
    const measuredLineSeries = this.appendSeries(svg, data, "line measured-flow-line", measuredLine);

    // Append the measured flow series circle outlines
    // svg.selectAll(".measured-flow-circle-outline")
    //     .data(this.data)
    //   .enter().append("circle")
    //     .attr("class", "measured-flow-circle-outline")
    //     .attr("cx", function(d) { return x(new Date(`${d.ddate} 00:00:00`)); })
    //     .attr("cy", function(d) { return y(d.measured_flow); })
    //     .attr("r", 6);

    // Append the measured flow series circles
    svg.selectAll(".measured-flow-circle")
        .data(this.data)
      .enter().append("circle")
        .attr("class", "measured-flow-circle")
        .attr("cx", function(d) { return x(new Date(`${d.ddate} 00:00:00`)); })
        .attr("cy", function(d) { return y(d.measured_flow); })
        .attr("r", 4);

    // Add an empty tooltip bar and line
    const tooltipBar = svg.append('line').attr('class', 'tooltip-line1');
    const tooltipLine = svg.append('line').attr('class', 'tooltip-line2');

    // Add an overlay to the chart so we can append the tooltip lines on hover
    const rect = svg.append("rect")
      .attr("transform", "translate(0,0)")
      .attr("class", "overlay")
      .style("opacity", 0)
      .attr("width", width)
      .attr("height", height)
      .on("mousemove", function() {
        self.generateTooltipLine("time-series", this, x, tooltipBar, tooltipLine)
      })
      .on("click", function() {
        self.updateBreakoutTable("time-series", this, x, tooltipBar, tooltipLine)
      });
    return this;
  }

}
